import { forwardRef } from "react";

import {
  ALERT_DEFAULTS,
  ALERT_VARIANT_CLASS_MAP,
  type TAlertProps,
} from "@/ui/components/feedback/Alert/Alert.config";
import { cn } from "@/ui/lib/utils";
import { AlertWrapper } from "./AlertWrapper";
import { AlertAsset } from "./AlertAsset";
import { AlertTitle } from "./AlertTitle";
import { AlertBody } from "./AlertBody";

export const Alert = forwardRef<HTMLDivElement, TAlertProps>(
  (
    {
      title,
      asset,
      children,
      className,
      variant = ALERT_DEFAULTS.variant,
      ...props
    },
    ref,
  ) => (
    <AlertWrapper
      {...props}
      data-component="Alert"
      ref={ref}
      asset={asset}
      className={cn(
        ALERT_VARIANT_CLASS_MAP[variant],
        className,
      )}>
      <AlertAsset asset={asset} />
      { title ? (
        <AlertTitle title={title} asset={asset} />
      ): null }
      <AlertBody asset={asset} hasTitle={!!title}>{ children }</AlertBody>
    </AlertWrapper>
  ),
);

Alert.displayName = "Alert";
